// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./js/components/EmptyArea/empty-area.scss
// module id = 865
// module chunks = 0